import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';

export default function validateInput(data) {
  const errors = {};

  if (Validator.isEmpty(data.description)) {
    errors.description = 'This field is required';
  } else if (!Validator.isLength(data.description, { min: 1, max: 80 })) {
    errors.description = 'This field is must be less than 80 characters';
  }

  if (Validator.isEmpty(data.amount)) {
    errors.amount = 'This field is required';
  }

  return { errors, isValid: isEmpty(errors) };
}
